import { useContext, useEffect, useState } from "react";

import promptStyle from "../prompt.module.css";
import buttonStyle from "../../Common/buttons.module.css";
import { useAuth0 } from "@auth0/auth0-react";
import { AuthContext } from "../../../contexts/AuthContext.ts";
import { apiResendVerificationEmail } from "../../../sdk.ts";
import { MailCheck, Send, X } from "lucide-react";

interface Props {
  advance: () => void;
}
function VerifyEmail({ advance }: Readonly<Props>) {
  const { user, logout } = useAuth0();
  const { token } = useContext(AuthContext);

  const [sentEmail, setSentEmail] = useState(false);

  useEffect(() => {
    if (!user) return;

    if (user.email_verified) {
      advance();
      console.log("Solved Email Verification");
    }
  }, [user, advance]);

  if (!user || user.email_verified) return;

  function resendEmail() {
    apiResendVerificationEmail(token);
    setSentEmail(true);
  }

  return (
    <div className={promptStyle.loneTextWrapper}>
      <h3 className={promptStyle.title}>
        Please{" "}
        <span className={promptStyle.blueText}>
          <MailCheck stroke="var(--light-blue-icon)" strokeWidth={1.5} className={promptStyle.adHocIcon} />
          verify your email
        </span>{" "}
        before continuing.
      </h3>
      <br />
      {sentEmail ? (
        <div className={promptStyle.emailHasBeenSent}>
          <h4>Verification email has been resent.</h4>
          <button
            onClick={() => {
              setSentEmail(false);
            }}
            className={buttonStyle.button + " " + buttonStyle.redOutline + " " + promptStyle.closeButton}
          >
            <X stroke="var(--red-button)" strokeWidth="2" />
            Back
          </button>
        </div>
      ) : (
        <div className={promptStyle.observations}>
          <h5>
            <span
              onClick={() => {
                logout({ logoutParams: { returnTo: window.location.origin } });
              }}
              className={buttonStyle.button + " " + buttonStyle.lightBlueOutline + " " + promptStyle.alreadyVerified}
            >
              I have already verified my email
            </span>
          </h5>
          <h4 className={promptStyle.bottomText}>
            Didn't receive anything? Try
            <span onClick={() => resendEmail()} className={promptStyle.numbering + " " + promptStyle.link}>
              <Send stroke="var(--light-blue-icon)" strokeWidth={1.5} className={promptStyle.adHocIcon} />
              resending email.
            </span>
          </h4>
        </div>
      )}
    </div>
  );
}

export default VerifyEmail;
